import { render, staticRenderFns } from "./HoldCodes.vue?vue&type=template&id=495b4494&scoped=true&"
import script from "./HoldCodes.vue?vue&type=script&lang=js&"
export * from "./HoldCodes.vue?vue&type=script&lang=js&"
import style0 from "./HoldCodes.vue?vue&type=style&index=0&id=495b4494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b4494",
  null
  
)

export default component.exports